import type React from 'react';
import { FormattedMessage } from 'react-intl';

import type { Company } from '@xing-com/crate-common-graphql-types';
import { IconArrowRight } from '@xing-com/icons';

import * as Styled from './logged-out-landing-page.style';

type CompaniesRowProps = {
  companies: Company[];
  totalCaption: string;
  showAllLink: string;
  title: string;
};

const CompaniesRow: React.FC<CompaniesRowProps> = ({
  companies,
  totalCaption,
  showAllLink,
  title,
}) => {
  return (
    <Styled.CompaniesRow>
      <Styled.CompaniesTitle size="large">
        <FormattedMessage id={title} />
      </Styled.CompaniesTitle>
      <Styled.CompaniesContainer>
        {companies.map((company) => (
          <Styled.Wrapper key={company?.id}>
            <Styled.CompanyCard company={company} />
          </Styled.Wrapper>
        ))}
        <Styled.ViewMoreWrapper>
          <Styled.ViewMoreInner>
            <Styled.ViewMoreLink to={showAllLink}>
              <Styled.ViewMoreCaption fontWeight="bold" size="medium">
                <FormattedMessage
                  id={totalCaption}
                  values={
                    {
                      span: (...text: any[]) => (
                        <Styled.ViewMoreCaptionHighlight>
                          {text}
                        </Styled.ViewMoreCaptionHighlight>
                      ),
                    } as unknown as Record<string, React.ReactNode>
                  }
                />
                <br />
                <IconArrowRight width="24" height="24" />
              </Styled.ViewMoreCaption>
            </Styled.ViewMoreLink>
          </Styled.ViewMoreInner>
        </Styled.ViewMoreWrapper>
      </Styled.CompaniesContainer>
    </Styled.CompaniesRow>
  );
};
export { CompaniesRow };
